import { render, staticRenderFns } from "./WaitingStatusScreen.vue?vue&type=template&id=33743548&scoped=true&"
import script from "./WaitingStatusScreen.vue?vue&type=script&lang=js&"
export * from "./WaitingStatusScreen.vue?vue&type=script&lang=js&"
import style0 from "./WaitingStatusScreen.vue?vue&type=style&index=0&id=33743548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33743548",
  null
  
)

export default component.exports